import React from 'react';
import PageDetail from './PageDetail';

const FoodDetail = (props) => {
  return <PageDetail tag='FOOD' url='/food-selection' id={props.match.params.id}/>;
}

export default FoodDetail;